<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-30 
-->
<template>
  <div class="main-container">
    <page-header>{{'添加同行人' | dealLanguage('Add travellers')}}</page-header>
    <div class="flex-wrapper">
      <div class="flex-left">
        <user-info-nav></user-info-nav>
      </div>
      <div class="flex-right">
        <div class="form-view newadd-form-view">
          <Form ref="companions-form" :model="currentForm" :rules="ruleValidate2">
            <div class="view-title">
              <div class="title">{{'同行人信息' | dealLanguage('Traveler information')}}</div>
              <div class="line"></div>
            </div>
            <Row :gutter="26">
              <Col span="6">
              <FormItem prop="mobileAreaCode" :label="'国家地区码' | dealLanguage('Area Code')">
                <Select v-model="currentForm.mobileAreaCode" :placeholder="'请选择国家/地区码' | dealLanguage('Please select a country/region code')">
                  <Option v-for="item in appMobileAreaCodeDtos" :value="item.mobileAreaCode" :key="item.mobileAreaCode">+{{item.mobileAreaCode}} ({{item.countryName}})</Option>
                </Select>
              </FormItem>
              </Col>
              <Col span="10">
              <FormItem prop="mobile" :label="'手机号码' | dealLanguage('Phone Number')">
                <Input type="text" v-model="currentForm.mobile" :placeholder="'请输入手机号' | dealLanguage('Please enter mobile phone number')" autocomplete="off"></Input>
              </FormItem>
              </Col>
              <Col span="8">
              <FormItem prop="mobileVerifyCode" :label="'验证码' | dealLanguage('Phone Code')">
                <Input type="text" class="right-padding" v-model="currentForm.mobileVerifyCode" :placeholder="'请填写验证码' | dealLanguage('Please fill in the verification code')"></Input>
                <Captcha
                  ref="captcha"
                  scene="vbdata_bidingmobile"
                  :mobile="currentForm.mobile"
                  :mobileAreaCode="currentForm.mobileAreaCode"
                ></Captcha>
              </FormItem>
              <FormItem v-if="ncStatus">
                <div class="nc-cnt">
                  <div id="nc"></div>
                </div>
              </FormItem>
              </Col>
            </Row>
            <FormItem prop="name" :label="'姓名' | dealLanguage('Name')">
              <Input type="text" v-model="currentForm.name" :placeholder="'请填写姓名' | dealLanguage('Please fill in your name')"></Input>
            </FormItem>
            <FormItem prop="compName" :label="'公司' | dealLanguage('Company')">
              <div class="input-tag">
                <AutoComplete v-model="entityKeyword" :placeholder="!currentForm.entityId ? filter.dealLanguage('请搜索并选择公司', 'Please search and select a company') : ''" @on-search="handleSearchEntity" @on-select="handleSelectEntity" @on-change="handleChangeEntity">
                  <Option v-for="item in entityList" :value="item.id" :key="item.id">
                    <div class="title">
                      {{item.shortName}}
                    </div>
                    <div class="desc">
                      {{item.description}}
                    </div>
                  </Option>
                </AutoComplete>
                <div class="tag-div" v-if="currentForm.entityId">
                  <Tag closable @on-close="handleClose" color="blue">{{currentForm.compName}}</Tag>
                </div>
              </div>
            </FormItem>
            <Row :gutter="26">
              <Col span="12">
              <FormItem prop="department" :label="'部门' | dealLanguage('Department')">
                <Input type="text" v-model="currentForm.department" :placeholder="'请填写部门' | dealLanguage('Please fill in the department')"></Input>
              </FormItem>
              </Col>
              <Col span="12">
              <FormItem prop="title" :label="'职位' | dealLanguage('Position')">
                <Input type="text" v-model="currentForm.title" :placeholder="'请填写职位' | dealLanguage('Please fill in the position')"></Input>
              </FormItem>
              </Col>
            </Row>
            <Row :gutter="26">
              <Col span="12">
              <FormItem prop="companyNatureId" :label="'请问贵公司性质' | dealLanguage('Company nature')">
                <treeselect v-model="currentForm.companyNatureId" :disableBranchNodes="true" 
                :placeholder="'请选择' | dealLanguage('Please select')" 
                :options="companyNatureTree" @input="handleChangeNT($event, 0)"
                v-if="language == 'zh'"
                />
                <treeselect v-model="currentForm.companyNatureId" :disableBranchNodes="true" 
                :placeholder="'请选择' | dealLanguage('Please select')" 
                :options="enCompanyNatureTree" @input="handleChangeNT($event, 0)"
                v-else
                />
              </FormItem>
              </Col>
              <Col span="12" v-if="compNTother">
              <FormItem prop="companyNatureOtherTagName" :label="compNTother">
                <Input type="text" v-model="currentForm.companyNatureOtherTagName" :placeholder="'请填写具体性质' | dealLanguage('Please fill in the specific nature')"></Input>
              </FormItem>
              </Col>
            </Row>
          </Form>
          <div class="checkbox-container">
            <div class="checkbox-tip-content" v-if="visible">
              <div class="checkbox-tip-arrow"></div>
              <div class="checkbox-tip-inner">{{'请阅读并勾选下方协议' | dealLanguage('Please read and check the agreement below')}}</div>
            </div>
            <Checkbox v-model="readSingle" size="small" @on-change="visible = false">
              <p class="checkbox-label">{{'我已阅读并同意' | dealLanguage('I have read and agreed to')}}<a :href="index2_path+'/mobile/privacyPolicy/2'" target="_blank">《动脉网用户协议》</a></p>
            </Checkbox>
          </div>
          <div class="checkbox-container">
            <div class="checkbox-tip-content" v-if="visible2">
              <div class="checkbox-tip-arrow"></div>
              <div class="checkbox-tip-inner">{{'请阅读并勾选下方协议' | dealLanguage('Please read and check the agreement below')}}</div>
            </div>
            <Checkbox v-model="readSingle2" size="small" @on-change="visible2 = false">
              <p class="checkbox-label">{{'我已阅读并同意' | dealLanguage('I have read and agreed to')}}<a :href="index2_path+'/mobile/privacyPolicy/1'" target="_blank">《隐私政策》</a></p>
            </Checkbox>
          </div>
          <div class="btn-wrapper">
            <Button @click="handleCloseAdd">
              <span>{{'取消' | dealLanguage('Cancel')}}</span>
            </Button>
            <Button type="primary" @click="handleSubmit2" :loading="buttonLoading">
              <span v-if="buttonLoading">{{'保存中' | dealLanguage('Loading')}}</span>
              <span v-else>{{'保存' | dealLanguage('SAVE')}}</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Agetmeta } from '@/service/app'
import PageHeader from '@/components/pc/pageHeader.vue'
import UserInfoNav from '@/components/pc/userInfoNav.vue'
import buildTree from 'js/buildTree'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { searchEntity } from 'js/searchEntity'
import { mapState } from 'vuex'
import { loginCommon } from '@/assets/js/login'
import { modifyPartner } from '@/service/vbef'
import filter from 'js/filter'
import Captcha from '@/components/common/captcha'
const MOBILE_REGEX = /^1[3-9]\d{9}$/
export default {
  metaInfo() {
    return {
      title: filter.dealLanguage('添加同行人', 'Add travellers'),
    }
  },
  mixins: [searchEntity, loginCommon],
  components: {
    PageHeader,
    UserInfoNav,
    Treeselect,
    Captcha
  },
  created() {
    this.Agetmeta()
  },
  mounted() {},
  data() {
    const _this = this
    return {
      filter,
      buttonLoading: false,
      companyNatureTags: [],
      companyNatureTree: [],
      enCompanyNatureTree: [],
      compNTother: '',
      currentForm: {
        compName: '',
        companyNatureId: null,
        companyNatureOtherTagName: '',
        department: '',
        entityId: 0,
        id: 0,
        mobile: '',
        mobileAreaCode: '86',
        mobileVerifyCode: '',
        name: '',
        title: '',
      },
      ruleValidate2: {
        name: [{ required: true, message: filter.dealLanguage('请填写姓名', 'Please fill in your name'), trigger: 'blur' }],
        compName: [{ required: true, message: filter.dealLanguage('请搜索并选择公司', 'Please search and select a company'), trigger: 'change' }],
        department: [{ required: true, message: filter.dealLanguage('请填写部门', 'Please fill in the department'), trigger: 'blur' }],
        title: [{ required: true, message: filter.dealLanguage('请填写职位', 'Please fill in the position'), trigger: 'blur' }],
        companyNatureId: [
          { required: true, type: 'number', message: filter.dealLanguage('请选择公司性质', 'Please select'), trigger: 'change' },
        ],
        companyNatureOtherTagName: [
          { required: true, message: filter.dealLanguage('请填写具体性质', 'Please fill in the specific nature'), trigger: 'blur' },
        ],
        mobileVerifyCode: [{ required: true, message: filter.dealLanguage('请填写正确的验证码', 'Please fill in the correct verification code'), trigger: 'blur' }],
        mobile: [
          { required: true, message: filter.dealLanguage('请输入您的手机号', 'Please enter your mobile number'), trigger: 'blur' },
          {
            type: 'number',
            message: filter.dealLanguage('手机号格式不正确', 'The phone number format is incorrect'),
            trigger: 'blur',
            transform(value) {
              if (_this.currentForm.mobileAreaCode == '86')
                return MOBILE_REGEX.test(value) ? Number(value) : false
            },
          },
        ],
      },
    }
  },
  computed: {
    ...mapState({
      appMobileAreaCodeDtos: (state) => state.appMobileAreaCodeDtos,
      language: (state) => state.language,
    }),
  },
  methods: {
    async Agetmeta() {
      let res = await Agetmeta({
        metaNameList: ['companyNatureTags'],
      })
      if (res.code != 0) return
      this.$set(this.$data, 'companyNatureTags', res.data.companyNatureTags)
      let enCompanyNatureTags = JSON.parse(JSON.stringify(res.data.companyNatureTags))
      res.data.companyNatureTags.forEach((tag) => {
        tag.label = tag.name
      })
      enCompanyNatureTags.forEach((tag) => {
        tag.label = tag.enName
      })
      const tree = buildTree(res.data.companyNatureTags)
      this.companyNatureTree = [...tree]

      const enTree = buildTree(enCompanyNatureTags)
      this.enCompanyNatureTree = [...enTree]

    },
    handleChangeNT(value, isfirst = 0) {
      if (!isfirst) this.currentForm.companyNatureOtherTagName = ''
      if (!value) {
        this.compNTother = ''
        return
      }
      let item = this.companyNatureTags.find((a) => a.id === value)
      if (item.name.indexOf('其他') > -1) {
        this.compNTother = item.name
      } else {
        this.compNTother = ''
      }
    },
    handleSubmit2() {
      if (this.buttonLoading) return
      this.$refs['companions-form'].validate(async (valid) => {
        if (valid) {
          if (!this.readSingle) {
            this.visible = true
            return
          }
          if (!this.readSingle2) {
            this.visible2 = true
            return
          }
          this.buttonLoading = true
          let res = await modifyPartner(this.currentForm)
          this.buttonLoading = false
          if (res.code == 0) {
            this.$Message.success(this.language == 'zh' ? '添加同行人成功！' : 'Adding companions successfully!')
            this.handleCloseAdd()
          } else {
            this.$Message.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
          }
        }
      })
    },
    handleCloseAdd() {
      this.$router.push({
        name: 'companions',
      })
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-pc.styl'
@import '~styles/form-view.styl'
.form-view
  padding-bottom 30px
.flex-right
  padding-right 120px
  .btn-wrapper
    margin-top 14px
    text-align center
  .form-btn
    color #fff
    background-color #FA5A00
    border-color #FA5A00
    box-shadow none
    transition all 0.3s
    width 100%
    height 40px
    font-size 16px
    margin-top 24px
    &:hover
      background-color #FF4800
      border-color #FF4800
</style>